import { render, staticRenderFns } from "./buscarPersona.vue?vue&type=template&id=38115980&"
import script from "./buscarPersona.vue?vue&type=script&lang=js&"
export * from "./buscarPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports